/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */
import type {
  AdminV1OrganizationsWorkoutsListParams,
  AdminWorkout,
  CopyWorkout,
  CopyWorkoutResponse,
  PatchedAdminWorkout,
  SwaggerAdminWorkoutList
} from '.././model';

import adminV1OrganizationsWorkoutsListMutator from '../../shared/services/axios-client';
import adminV1OrganizationsWorkoutsCreateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsWorkoutsRetrieveMutator from '../../shared/services/axios-client';
import adminV1OrganizationsWorkoutsUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsWorkoutsPartialUpdateMutator from '../../shared/services/axios-client';
import adminV1OrganizationsWorkoutsDestroyMutator from '../../shared/services/axios-client';
import adminV1OrganizationsWorkoutsCopyWorkoutCreateMutator from '../../shared/services/axios-client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsWorkoutsList = (
    organizationId: number,
    params: AdminV1OrganizationsWorkoutsListParams,
 options?: SecondParameter<typeof adminV1OrganizationsWorkoutsListMutator<SwaggerAdminWorkoutList>>,) => {
      return adminV1OrganizationsWorkoutsListMutator<SwaggerAdminWorkoutList>(
      {url: `/api/admin/v1/organizations/${organizationId}/workouts/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsWorkoutsCreate = (
    organizationId: number,
    adminWorkout: NonReadonly<AdminWorkout>,
 options?: SecondParameter<typeof adminV1OrganizationsWorkoutsCreateMutator<AdminWorkout>>,) => {
      return adminV1OrganizationsWorkoutsCreateMutator<AdminWorkout>(
      {url: `/api/admin/v1/organizations/${organizationId}/workouts/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: adminWorkout
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsWorkoutsRetrieve = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsWorkoutsRetrieveMutator<AdminWorkout>>,) => {
      return adminV1OrganizationsWorkoutsRetrieveMutator<AdminWorkout>(
      {url: `/api/admin/v1/organizations/${organizationId}/workouts/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsWorkoutsUpdate = (
    organizationId: number,
    id: number,
    adminWorkout: NonReadonly<AdminWorkout>,
 options?: SecondParameter<typeof adminV1OrganizationsWorkoutsUpdateMutator<AdminWorkout>>,) => {
      return adminV1OrganizationsWorkoutsUpdateMutator<AdminWorkout>(
      {url: `/api/admin/v1/organizations/${organizationId}/workouts/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: adminWorkout
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsWorkoutsPartialUpdate = (
    organizationId: number,
    id: number,
    patchedAdminWorkout: NonReadonly<PatchedAdminWorkout>,
 options?: SecondParameter<typeof adminV1OrganizationsWorkoutsPartialUpdateMutator<AdminWorkout>>,) => {
      return adminV1OrganizationsWorkoutsPartialUpdateMutator<AdminWorkout>(
      {url: `/api/admin/v1/organizations/${organizationId}/workouts/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedAdminWorkout
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsWorkoutsDestroy = (
    organizationId: number,
    id: number,
 options?: SecondParameter<typeof adminV1OrganizationsWorkoutsDestroyMutator<void>>,) => {
      return adminV1OrganizationsWorkoutsDestroyMutator<void>(
      {url: `/api/admin/v1/organizations/${organizationId}/workouts/${id}/`, method: 'DELETE'
    },
      options);
    }
  /**
 * Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 * @summary Mixin for admin views that are scoped to a specific organization.
Handles organization filtering and permission checking.
 */
export const adminV1OrganizationsWorkoutsCopyWorkoutCreate = (
    organizationId: number,
    copyWorkout: CopyWorkout,
 options?: SecondParameter<typeof adminV1OrganizationsWorkoutsCopyWorkoutCreateMutator<CopyWorkoutResponse>>,) => {
      return adminV1OrganizationsWorkoutsCopyWorkoutCreateMutator<CopyWorkoutResponse>(
      {url: `/api/admin/v1/organizations/${organizationId}/workouts/copy_workout/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: copyWorkout
    },
      options);
    }
  export type AdminV1OrganizationsWorkoutsListResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsWorkoutsList>>>
export type AdminV1OrganizationsWorkoutsCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsWorkoutsCreate>>>
export type AdminV1OrganizationsWorkoutsRetrieveResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsWorkoutsRetrieve>>>
export type AdminV1OrganizationsWorkoutsUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsWorkoutsUpdate>>>
export type AdminV1OrganizationsWorkoutsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsWorkoutsPartialUpdate>>>
export type AdminV1OrganizationsWorkoutsDestroyResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsWorkoutsDestroy>>>
export type AdminV1OrganizationsWorkoutsCopyWorkoutCreateResult = NonNullable<Awaited<ReturnType<typeof adminV1OrganizationsWorkoutsCopyWorkoutCreate>>>
